import { optionsMap } from 'pro-gallery-lib';
export const GALLERY = {
  GALLERY_RATIO_METHOD: "controllers_layoutParams_structure_galleryRatio_method",
  GALLERY_RATIO_VALUE: "controllers_layoutParams_structure_galleryRatio_value"
};
export const GALLERY_CONTROLLERS = {
  [GALLERY.GALLERY_RATIO_VALUE]: (value, options) => {
    const method = options[GALLERY.GALLERY_RATIO_METHOD];
    if (method === 'FIXED') {
      return {
        [optionsMap.layoutParams.structure.galleryRatio.value]: 1 / value
      }; // (1/ value) as the height is defined in the gallery by the width and 16:9 means 9/16 height for 1 width
    } else {
      return {
        [optionsMap.layoutParams.structure.galleryRatio.value]: 0
      };
    }
  }
};
//# sourceMappingURL=gallery.js.map